
import { Component, Prop, Vue } from 'vue-property-decorator';
import BodyParagraph from './BodyParagraph.vue';

@Component
export default class BodyLink extends BodyParagraph {}
